import { Container, Row, Col, Button } from 'react-bootstrap'
import LoginForm from '../../components/LoginForm/LoginForm'
import './Login.css'


import './Login.css'

const Login = () => {

    return (
        <Container className="Login">
            <LoginForm />

        </Container>
    )
}

export default Login

